import React, { useEffect, useState } from "react";
import {
  FaFileAlt,
  FaFlask,
  FaHistory,
  FaUnlock,
} from "react-icons/fa";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom"; 
//import styles from "./sidebar.module.css";
import Guideline from "../Guideline";
import AddGuideline from "../AddGuideline";
import Document from "../Document"; 
import DataAccessRights from "../DataAccessRights"; 
import HistoryDataAccessRights from "../HistoryDataAccessRights"; 
import PermisstionLabPatient from "../PermisstionLabPatient"; 
;
  
const Sidebar = ({ role, page, subsection, action }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [submenuOpen, setSubmenuOpen] = useState(0);
  const [activeMenu, setActiveMenu] = useState(page);
  const [activeSubMenu, setActiveSubMenu] = useState(subsection);

  const navigate = useNavigate();

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
    if (isOpen) {
      setSubmenuOpen(0);
    }
  };

  const handleMenuClick = (menu) => {
    if (!isOpen) {
      setIsOpen(true);
    } 

    navigate(`/doctor/${menu}`);
    setActiveMenu(menu); 
    setActiveSubMenu(''); 
  };
 
 
  const renderContent = () => {  
    
    if (activeMenu == "guideline") {
      if (activeSubMenu == "add") {
        return <AddGuideline />;
      } else {
        return <Guideline />;
      }
    } else if (activeMenu == "document") {
      return <Document />;
    } else if (activeMenu == "access-rights") {
      return <DataAccessRights />;
    } else if (activeMenu == "history-access-rights") {
      return <HistoryDataAccessRights />;
    } else if (activeMenu == "permission-lab-patient") {
      return <PermisstionLabPatient />;
    }
    ;
     
  };

  return (
    <div style={styles.wrapper}>
      <div
        style={{
          ...styles.sidebar,
          width: isOpen ? "263px" : "59px",
        }}
        onMouseEnter={() =>
          isOpen === false && window.innerWidth >= 768 && setIsOpen(true)
        }
        // onMouseLeave={() =>
        //   isOpen === true && window.innerWidth >= 768 && setIsOpen(false)
        // }
      >
        <div
          style={{
            ...styles.header,
            justifyContent: isOpen ? "space-between" : "center",
            padding: isOpen ? "0px 15px 0px 15px" : "",
          }}
        >
          {isOpen && <p style={styles.headerText}>สำหรับแพทย์</p>}
          <button
            style={styles.toggleButton}
            onClick={toggleSidebar}
            aria-label={isOpen ? "Close Sidebar" : "Open Sidebar"}
          >
            {isOpen ? (
              <div className="flex justify-center items-center text-[30px] w-[40px] h-[40px]">
                -
              </div>
            ) : (
              <div className="flex justify-center items-center text-[30px] w-[40px] h-[40px]">
                +
              </div>
            )}
          </button>
        </div>
        <div style={styles.menu}>
          {/* menu 1 */}
          <div
            style={styles.menuItem}
            onClick={() => {
              handleMenuClick("guideline");
            }}
          >
            <div
              className="flex flex-row items-center gap-[10px] justify-start w-full pl-3 pr-3 active:h-[42px] active:rounded-[6px]"
              style={{
                justifyContent: isOpen ? "start" : "center",
                backgroundColor: activeMenu === "guideline" ? "#00917E" : "",
                color: activeMenu === "guideline" ? "#fff" : "",
                height: activeMenu === "guideline" ? "42px" : "",
                borderRadius: activeMenu === "guideline" ? "6px" : "",
              }}
            >
              <FaFlask style={{ width: "18px" }} />
              {isOpen && <span style={styles.text}>แนวทางการตรวจ</span>}
            </div>
          </div>
          {/* menu 2 */}
          <div
            style={styles.menuItem}
            onClick={() => {
              handleMenuClick("document");
            }}
          >
            <div
              className="flex flex-row items-center gap-[10px] justify-start w-full pl-3 pr-3 active:h-[42px] active:rounded-[6px]"
              style={{
                justifyContent: isOpen ? "start" : "center",
                backgroundColor: activeMenu === "document" ? "#00917E" : "",
                color: activeMenu === "document" ? "#fff" : "",
                height: activeMenu === "document" ? "42px" : "",
                borderRadius: activeMenu === "document" ? "6px" : "",
              }}
            >
              <FaFileAlt style={{ width: "18px" }} />
              {isOpen && <span style={styles.text}>เอกสารที่เกี่ยวข้อง</span>}
            </div>
          </div>
          {/* menu 3 */}
          <div
            style={styles.menuItem}
            onClick={() => {
              handleMenuClick("access-rights");
            }}
          >
            <div
              className="flex flex-row items-center gap-[10px] justify-start w-full pl-3 pr-3 active:h-[42px] active:rounded-[6px]"
              style={{
                justifyContent: isOpen ? "start" : "center",
                backgroundColor:
                  activeMenu === "access-rights" ? "#00917E" : "",
                color: activeMenu === "access-rights" ? "#fff" : "",
                height: activeMenu === "access-rights" ? "42px" : "",
                borderRadius: activeMenu === "access-rights" ? "6px" : "",
              }}
            >
              <FaUnlock style={{ width: "18px" }} />
              {isOpen && (
                <span style={styles.text}>
                  รายชื่อผู้ป่วยที่มีสิทธิเข้าถึงข้อมูล
                </span>
              )}
            </div>
          </div>

          {/* menu 4 */}
          <div
            style={styles.menuItem}
            onClick={() => {
              handleMenuClick("history-access-rights");
            }}
          >
            <div
              className="flex flex-row items-center gap-[10px] justify-start w-full pl-3 pr-3 active:h-[42px] active:rounded-[6px]"
              style={{
                justifyContent: isOpen ? "start" : "center",
                backgroundColor:
                  activeMenu === "history-access-rights" ? "#00917E" : "",
                color: activeMenu === "history-access-rights" ? "#fff" : "",
                height: activeMenu === "history-access-rights" ? "42px" : "",
                borderRadius:
                  activeMenu === "history-access-rights" ? "6px" : "",
              }}
            >
              <FaHistory style={{ width: "18px" }} />
              {isOpen && (
                <span style={styles.text}>ประวัติการขอเข้าถึงข้อมูล</span>
              )}
            </div>
          </div>
        </div>
      </div>

      <div style={styles.container}>{renderContent()}</div>
    </div>
  );
};

const styles = {
  wrapper: {
    display: "flex",
    width: "100%",
    backgroundColor: "#f4f4f4",
  },
  sidebar: {
    background: "#F5FFFA",
    color: "#00917E",
    transition: "width 0.3s",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    boxShadow: "2px 0 5px rgba(0, 0, 0, 0.1)",
    paddingTop:"10px",
  },
  container: {
    flex: 1,
    position: "relative",
    padding: "20px",
    whiteSpace: "nowrap",
    overflow: "auto",
    backgroundColor: "white",
  },
  header: {
    display: "flex",
    alignItems: "center",
    height: "50px",
  },
  headerText: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#00917E",
    lineHeight: "42px",
    fontFamily: "Prompt, sans-serif",
  },
  toggleButton: {
    background: "#F5FFFA",
    color: "#00917E",
    border: "1px solid #93D3B1",
    borderRadius: "6px",
    cursor: "pointer",
    padding: "2px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  menu: {
    display: "flex",
    flexDirection: "column",
    padding: "10px 0",
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    padding: "0 5px",
    justifyContent: "space-between",
    height: "50px",
    cursor: "pointer",
  },
  submenu: {
    borderLeft: "2px solid #93D3B1",
    listStyleType: "disc",
    color: "#00917E",
  },
  submenuItem: {
    display: "flex",
    alignItems: "center",
    padding: "5px 0",
    height: "50px",
    cursor: "pointer",
    transition: "background-color 0.3s",
    margin: "0px 5px",
  },
  submenuItemActive: {
    backgroundColor: "#00917E",
    color: "#fff",
    borderRadius: "6px",
  },
  text: {
    fontSize: "14px",
    fontWeight: "400",
    whiteSpace: "nowrap",
  },
};

export default Sidebar;
